if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class ProductRecentlyViewed extends HTMLElement {
      constructor() {
        super();
      }

      get layout() {
        return this._layout = this._layout || this.dataset.layout;
      }

      connectedCallback() {
        createObserver({
          element: this,
          callback: this.init.bind(this),
          threshold: 400
        });
      }

      readCookie (name) {
        let list = [],
        data = getCookie(name);

        if (data !== null && data !== undefined && data !== '') list = data.split(' ');
        return list;
      }

      getQueryString(list) {
        if (this.dataset.productId && list.includes(parseInt(this.dataset.productId))) list.splice(list.indexOf(parseInt(this.dataset.productId)), 1);
        return list.map((item) => "id:" + item).slice(0, 10).join(" OR ");
      }

      init() {
        this.list = this.readCookie('shopify_recently_viewed_products');
        if(this.list.length === 0) {
          this.checkContent();
          return
        }
        this.loadContent();
      }

      checkContent(html = null){
        this.setAttribute('loaded', true);
        this.products = html ? Array.from(html.querySelectorAll('[data-product-item]')) : [];
        
        if(this.products.length === 0) {
          if(this.layout == 'section') {
            this.closest('.shopify-section')?.remove();
          } else if(this.layout == 'drawer') {
            this.classList.add('is-empty');
          }
        }
      }

      loadContent() {
        if (!this.getAttribute('loaded')) {
          fetch(this.dataset.url + this.getQueryString(this.list))
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const products = html.querySelector('recently-viewed-products');

              if (products && products.innerHTML.trim().length) this.innerHTML = products.innerHTML;
              this.checkContent(html);
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }
    }
  );
}